/**
 * Environment-aware URL utilities for BFF (Backend-For-Frontend) architecture
 *
 * In production, the frontend and backend are served from the same origin,
 * so client-side code uses window.location.origin (no build-time URL baking).
 * This allows the same static build to be deployed to any environment.
 *
 * In local development, the Vite dev server proxies /auth/* and /api/* to
 * the backend, so same-origin calls continue to work. Set VITE_BACKEND_V3_URL
 * to bypass the proxy for direct backend access.
 */

export function getBackendUrl(): string {
  const override = import.meta.env.VITE_BACKEND_V3_URL;
  if (override) {
    return override;
  }

  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "[::1]";

  if (isLocalhost) {
    // Local dev: Vite proxy keeps same-origin for /auth and /api.
    return window.location.origin;
  }

  // Production/staging: BFF same-origin, use current origin.
  return window.location.origin;
}
